module.exports = __webpack_public_path__ + "img/myvoice-small.09c940ef.png";